import { render, staticRenderFns } from "./SendToCustomerCommand.vue?vue&type=template&id=d83fc150&scoped=true&"
import script from "./SendToCustomerCommand.vue?vue&type=script&lang=ts&"
export * from "./SendToCustomerCommand.vue?vue&type=script&lang=ts&"
import style0 from "./SendToCustomerCommand.vue?vue&type=style&index=0&id=d83fc150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83fc150",
  null
  
)

export default component.exports